import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Menu } from 'app/shared/models/control/menu';

/**
 * The Epic-style icon rail: Home + one icon button per top-level PagesMenu module. Purely
 * presentational selection state - navigation/expand decisions live in MenuNavigationService,
 * not here.
 */
@Component({
    selector: 'app-shell-rail',
    templateUrl: './app-shell-rail.component.html',
    styleUrls: ['./app-shell-rail.component.scss'],
})
export class AppShellRailComponent {
    @Input() railModules: Menu[] = [];
    @Input() activeModuleId: number | null = null;
    @Input() isHome = true;
    /** Drives the menu handle glyph, its aria-expanded state and its open styling. */
    @Input() menuOpen = true;

    @Output() readonly goHome = new EventEmitter<void>();
    @Output() readonly selectModule = new EventEmitter<number>();
    @Output() readonly toggleMenuOpen = new EventEmitter<void>();
}
